import { format } from 'date-fns';

const format_date_time = (date, time) => {
    return date && format(date, 'yyyy-MM-dd') + 'T' + time;
};

export { format_date_time }